import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const postTrackAddGameStarted = (gameKey) => axios.post(`${SYMFONY_API_BASE_URL}/api/trackGameAdd/v1`, {
    gameKey: gameKey,
});
export default postTrackAddGameStarted;
